// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const tugotvColors: ColorType = { ...colorPalette, primary: '#EA2052', secondary: '#EA2052' }

export const lightTheme = {
  colors: tugotvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: tugotvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: tugotvColors.dark,
    secondary: tugotvColors.grayText,
    disabled: tugotvColors.dark,
    link: tugotvColors.dark,
    hint: tugotvColors.dark,
    highlight: tugotvColors.secondary,
    gray: tugotvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#000000',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: tugotvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: tugotvColors.dark,
    color: tugotvColors.dark,
    border: tugotvColors.primary,
    scrollbarThumb: tugotvColors.primary,
    programTitle: tugotvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: tugotvColors.dark,
        selected: tugotvColors.dark,
        progress: rgba(tugotvColors.primary, 0.3),
        past: rgba(tugotvColors.primary, 0.3),
        pastSelected: tugotvColors.dark,
        pastHover: tugotvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(tugotvColors.primary, 0.1),
      },
      text: {
        empty: tugotvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: tugotvColors.dark,
    subTitle: tugotvColors.grayText,
    bg: tugotvColors.dark,
    number: tugotvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 140,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
